import { DatatableVersionSelector } from '@/components/Studies/DataTables/Display/DatatableVersionSelector';

export default DatatableVersionSelector;
